import { CheckCircleFilled } from "@ant-design/icons";
import {
  FinancialBrand,
  SuccessStepAssets,
} from "@dreambigger/shared/src/types";
import { getIcon } from "@dreambigger/design-system/src/utils";
import animations from "@dreambigger/design-system/src/styles/modules/animations.module.scss";
import Confetti from "react-confetti";
import { ProductsSliderModal } from "../../components";
import React from "react";

interface SuccessContentV1Props {
  brand: FinancialBrand;
  title: string;
  subTitle?: string;
  description: string;
  assets?: SuccessStepAssets;
  children?: React.ReactNode;
  isAdminMode: boolean;
}

const SuccessContentV1 = ({
  brand,
  title,
  subTitle,
  description,
  assets,
  children,
  isAdminMode,
}: SuccessContentV1Props) => {
  return (
    <div className="min-h-100vh w-100">
      {!isAdminMode && !assets?.disableConfetti && (
        <Confetti
          recycle={false}
          numberOfPieces={900}
          tweenDuration={12000}
          className="fixed z-0"
        />
      )}
      <div
        className={`${animations.enter_s} flex flex-column justify-center mt-10 pa-4 xxl_pa-6 br-2 ba b-primary w-100 xxl_w-90 mh-auto`}
        style={{ background: "white" }}
      >
        {assets?.icon ? (
          <div
            className={`${
              !assets.iconColor && "primary"
            } flex flex-column items-center mt-4`}
            style={{ color: assets.iconColor }}
          >
            {getIcon(assets.icon, 6)}
          </div>
        ) : (
          <CheckCircleFilled
            className="mt-4 self-center"
            style={{ color: "#60d936", fontSize: "80px" }}
          />
        )}

        <h1
          className="f-7 md_f-8 xl_f-9 xxl_f-10 fwt mt-6 lh-1 tc"
          style={{ color: brand.stepTitleColor || "black" }}
        >
          {title}
        </h1>
        {subTitle && (
          <h2
            className="f-5 xl_f-6 gray-7 mt-5 tc"
            dangerouslySetInnerHTML={{
              __html: subTitle ?? "",
            }}
          />
        )}
        <p
          className="f-4 md_mt-6 mt-4 mb-6"
          dangerouslySetInnerHTML={{
            __html: description ?? "",
          }}
        />
        {/* If products have been configured to be shown, display a modal after a specified # of milliseconds. */}
        {/* @deprecated ProductsSliderModal is deprecated and will be removed in a future release. */}
        {assets?.featuredProductsModal?.products && (
          <ProductsSliderModal
            products={assets.featuredProductsModal?.products}
            modalTitle={
              assets.featuredProductsModal.title ||
              "Get the most out of your new membership!"
            }
            modalSubtitle={
              assets.featuredProductsModal.subtitle ||
              "You're pre-qualified for the following products:"
            }
            accentColor={brand.primaryColor || "black"}
            loadDelay={
              assets.featuredProductsModal.loadDelay || 4000
            }
          />
        )}
        {children}
      </div>
    </div>
  );
};

export default SuccessContentV1;
